import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import TicketCard from '../../../components/lottery/TicketCard/TicketCard';
import type { CaseSimulatorTicketsGridProps } from '../../../types/features/caseSimulator';

const CaseSimulatorTicketsGrid: React.FC<CaseSimulatorTicketsGridProps> = ({
  barcodeMode,
  processedPacks,
  scannerConfig,
  storeId,
  onPackReturn,
}) => {
  if (processedPacks.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No Activated Packs
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Create your first pack to get started
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {processedPacks.map((pack) => (
        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }} key={pack.pack_id}>
          <TicketCard
            barcodeMode={barcodeMode}
            pack={pack}
            scannerConfig={scannerConfig}
            onPackReturn={onPackReturn}
            storeId={storeId}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(CaseSimulatorTicketsGrid);
